/*
 * 原房间信息
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/reserveExchange';
import RoomInfo from '@/pages/reservation/roomExchange/components/RoomInfo';

const stateSelector = (state: ReducerState) => {
  const { channelInfo, rentTimeInfo, rentRoomInfos } = state;
  return { channelInfo, rentTimeInfo, rentRoomInfos };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { channelInfo, rentTimeInfo, rentRoomInfos } = props;
  return (
    <RoomInfo
      bizType="reserve"
      rentTimeInfo={rentTimeInfo}
      channelInfo={channelInfo}
      rentRoomInfos={rentRoomInfos}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
